import React from 'react';

export default class PictureStoryPage extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    let {imageURL} = this.props;
    if(imageURL && process.env.ASSET_ROOT){
      imageURL = imageURL.replace("s3.amazonaws.com/amira-assets",process.env.ASSET_ROOT);
    }

    let imageProvided = !!imageURL && imageURL !== '';

    return (
      <div className="pictureStoryPage">
        {imageProvided && <img className="pageImage" src={imageURL} alt="" />}
        <div className="pagePhrase">{this.props.phrase}</div>
      </div>
    );
  }
}
